import React, {useState} from "react";
import './PasswordToggle.css'

function PasswordToggle(){
    const [visible , setVisible] = useState(false);
    const inputType = visible ? "text" : "password";
    const Icon = <i className={visible ? "fa fa-eye" : "fa fa-eye-slash color_gray"}
        onClick={()=> setVisible(visible => ! visible)}
        style={{fontSize: "20px"}}
    ></i>;
    return [inputType, Icon];
}

export default PasswordToggle;